﻿import {Grid, GridOwnProps} from "@mui/material";

/**
 * Grid component with default spacing used to contain a TabContext MUI component
 * @param props Grid props passed to the inner Grid
 * @constructor
 * @example
 *   <TabContextContainer>
 *     <TabContext value={currentTab + ''}>
 *       <TabsContainer>
 *         <Tabs>
 *           ...
 *         </Tabs>
 *       </TabsContainer>
 *     </TabContext>
 *   </TabContextContainer>
 */
export const TabContextContainer = (props: GridOwnProps) => {
  return <Grid container {...props} />
}
